import React from 'react';
import * as Images from '../../assets';
import { Box, Grid } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { DarkBlueButton } from '../../components';

const Pricing = () => {
  return (
    <div
      id="Pricing"
      style={{
        backgroundImage: `url('${Images.homePage5}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        transition:
          'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
      }}
    >
      <div
        className="h-full w-full flex justify-center flex-col items-center gap-6 lg:py-32 md:py-16 py-12 lg:px-12 md:px-8 px-6 text-white"
        style={{
          backgroundColor: 'transparent',
          backgroundImage:
            'radial-gradient(at center center, #3b567a9e 55%, #1B2E48CC 100%)',
          transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        }}
      >
        <Box
          sx={{ width: { lg: '80%', md: '95%', sm: '100%', xs: '100%' } }}
          //className="lg:w-[80%] md:w-[95%] w-[100%]"
        >
          <Grid
            container
            spacing={6}
            className="flex justify-center lg:px-24 md:px-6 px-4"
          >
            <Grid className="flex flex-col items-center" item lg={4} xs={12}>
              <div className="flex flex-col gap-14">
                <div>
                  <div className="text-[var(--blue)] text-sm font-[600] tracking-[3px] mb-3">
                    PRICING
                  </div>
                  <div className="divider-light" />
                </div>
                <div className="text-5xl font-bold leading-[1.3]">
                  14 Day FREE trial on all paid plans
                </div>
                <div className="text-xs ">
                  <div>All our paid plans always include:</div>
                  <div className="space-y-3 mt-2">
                    <div>
                      ✓ Full access to all active and open tenders in our notice
                      board.
                    </div>

                    <div>
                      ✓ Customised Alert Service with daily email send to your
                      inbox.
                    </div>

                    <div>
                      ✓ Multiple Alert Recipients add your colleagues at no
                      extra charge.
                    </div>

                    <div>
                      ✓ Advanced Search filters by categories, locations and
                      organisations.{' '}
                    </div>

                    <div>
                      ✓ Company dashboard and free support in the subscription
                      period.
                    </div>
                    <div>
                      ✓ Inclusion in our searchable supplier directory (only in
                      our Alert Service and supplier directory subscription).
                    </div>
                    <div>
                      Choose a subscription plan, a payment method and get
                      started
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item lg={8} xs={12}>
              <div className="mb-6 font-bold text-md text-center">
                14 Day FREE trial on all paid plans. No money charged in FREE
                period!
              </div>
              <Grid container spacing={2} className="z-[10]">
                <Grid
                  //className="flex flex-col items-center"
                  item
                  lg={4}
                  md={4}
                  xs={12}
                >
                  <div className="py-6 h-full w-full">
                    <div className="h-full w-full">
                      <div className="bg-[var(--dark-blue)] px-3 py-5 flex flex-col gap-2">
                        <div className="text-center font-bold">Basic</div>
                        <div className="text-xs text-center flex flex-col gap-2">
                          <span>For suppliers looking to sample</span>
                          <span> Tender Notice Board</span>
                        </div>
                      </div>
                      <div className="bg-white text-[var(--dark-blue)] flex flex-col gap-2 py-8">
                        <div className="text-center font-bold">
                          <span className="text-6xl">
                            <sup className="text-3xl">$</sup>99
                            <sup className="text-3xl">00</sup>
                          </span>
                        </div>
                        <div className="text-sm text-center mb-6">
                          per month / Billed monthly
                        </div>
                        <div className="px-4 flex justify-center items-center flex-col gap-4">
                          <div className="text-sm text-center">
                            US$ 1.188,- for 12 months
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> Access to
                            all open & live tenders
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> Daily e-mail
                            notification
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> 7 Day free
                            trial
                          </div>

                          <DarkBlueButton className="w-full" size="large">
                            GET STARTED
                          </DarkBlueButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid
                  //className="flex flex-col items-center"
                  item
                  lg={4}
                  md={4}
                  xs={12}
                >
                  <div className="w-full h-full bg-white">
                    <div className="h-[25%] bg-[var(--dark-blue)] px-3 py-5 flex flex-col justify-center gap-2">
                      <div className="text-center font-bold">Basic</div>
                      <div className="text-xs text-center flex flex-col gap-2">
                        <span>For suppliers looking to sample</span>
                        <span> Tender Notice Board</span>
                      </div>
                    </div>
                    <div className="h-[75%] bg-white text-[var(--dark-blue)] flex flex-col gap-2 py-8">
                      <div className="text-center font-bold">
                        <span className="text-6xl">
                          <sup className="text-3xl">$</sup>99
                          <sup className="text-3xl">00</sup>
                        </span>
                      </div>
                      <div className="text-sm text-center mb-6">
                        per month / Billed monthly
                      </div>
                      <div className="px-4 flex justify-center items-center flex-col gap-4">
                        <div className="text-sm text-center">
                          US$ 1.188,- for 12 months
                        </div>
                        <hr className="w-full" />
                        <div className="flex gap-2 items-center text-sm text-center">
                          <CheckCircleOutline fontSize="small" /> Access to all
                          open & live tenders
                        </div>
                        <hr className="w-full" />
                        <div className="flex gap-2 items-center text-sm text-center">
                          <CheckCircleOutline fontSize="small" /> Daily e-mail
                          notification
                        </div>
                        <hr className="w-full" />
                        <div className="flex gap-2 items-center text-sm text-center">
                          <CheckCircleOutline fontSize="small" /> 7 Day free
                          trial
                        </div>

                        <DarkBlueButton className="w-full" size="large">
                          GET STARTED
                        </DarkBlueButton>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid
                  //className="flex flex-col items-center"
                  item
                  lg={4}
                  md={4}
                  xs={12}
                >
                  <div className="py-6 h-full w-full">
                    <div className="h-full w-full">
                      <div className="bg-[var(--dark-blue)] px-3 py-5 flex flex-col gap-2">
                        <div className="text-center font-bold">Basic</div>
                        <div className="text-xs text-center flex flex-col gap-2">
                          <span>For suppliers looking to sample</span>
                          <span> Tender Notice Board</span>
                        </div>
                      </div>
                      <div className="bg-white text-[var(--dark-blue)] flex flex-col gap-2 py-8">
                        <div className="text-center font-bold">
                          <span className="text-6xl">
                            <sup className="text-3xl">$</sup>99
                            <sup className="text-3xl">00</sup>
                          </span>
                        </div>
                        <div className="text-sm text-center mb-6">
                          per month / Billed monthly
                        </div>
                        <div className="px-4 flex justify-center items-center flex-col gap-4">
                          <div className="text-sm text-center">
                            US$ 1.188,- for 12 months
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> Access to
                            all open & live tenders
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> Daily e-mail
                            notification
                          </div>
                          <hr className="w-full" />
                          <div className="flex gap-2 items-center text-sm text-center">
                            <CheckCircleOutline fontSize="small" /> 7 Day free
                            trial
                          </div>

                          <DarkBlueButton className="w-full" size="large">
                            GET STARTED
                          </DarkBlueButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default Pricing;
